function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var isStyleObject = function isStyleObject(obj) {
  return _typeof(obj) === "object" && obj !== null;
};

var InternalOTPInput = function InternalOTPInput(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      _ref$numInputs = _ref.numInputs,
      numInputs = _ref$numInputs === void 0 ? 4 : _ref$numInputs,
      onChange = _ref.onChange,
      onPaste = _ref.onPaste,
      renderInput = _ref.renderInput,
      _ref$shouldAutoFocus = _ref.shouldAutoFocus,
      shouldAutoFocus = _ref$shouldAutoFocus === void 0 ? false : _ref$shouldAutoFocus,
      _ref$inputType = _ref.inputType,
      inputType = _ref$inputType === void 0 ? "text" : _ref$inputType,
      renderSeparator = _ref.renderSeparator,
      placeholder = _ref.placeholder,
      containerStyle = _ref.containerStyle,
      inputStyle = _ref.inputStyle,
      _ref$skipDefaultStyle = _ref.skipDefaultStyles,
      skipDefaultStyles = _ref$skipDefaultStyle === void 0 ? false : _ref$skipDefaultStyle;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeInput = _React$useState2[0],
      setActiveInput = _React$useState2[1];

  var inputRefs = React.useRef([]);

  var getOTPValue = function getOTPValue() {
    return value ? value.toString().split("") : [];
  };

  var isInputNum = inputType === "number" || inputType === "tel";
  React.useEffect(function () {
    inputRefs.current = inputRefs.current.slice(0, numInputs);
  }, [numInputs]);
  React.useEffect(function () {
    if (shouldAutoFocus) {
      var _inputRefs$current$;

      (_inputRefs$current$ = inputRefs.current[0]) === null || _inputRefs$current$ === void 0 ? void 0 : _inputRefs$current$.focus();
    }
  }, [shouldAutoFocus]);

  var getPlaceholderValue = function getPlaceholderValue() {
    if (typeof placeholder === "string") {
      if (placeholder.length === numInputs) {
        return placeholder;
      }

      if (placeholder.length > 0) {
        console.error("Length of the placeholder should be equal to the number of inputs.");
      }
    }

    return undefined;
  };

  var isInputValueValid = function isInputValueValid(value) {
    var isTypeValid = isInputNum ? !isNaN(Number(value)) : typeof value === "string";
    return isTypeValid && value.trim().length === 1;
  };

  var handleChange = function handleChange(event) {
    var value = event.target.value;

    if (isInputValueValid(value)) {
      changeCodeAtFocus(value);
      focusInput(activeInput + 1);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var nativeEvent = event.nativeEvent;
    var value = event.target.value;

    if (!isInputValueValid(event.target.value)) {
      // Pasting from the native autofill suggestion on a mobile device can pass
      // the pasted string as one long input to one of the cells. This ensures
      // that we handle the full input and not just the first character.
      if (value.length === numInputs) {
        var hasInvalidInput = value.split("").some(function (cellInput) {
          return !isInputValueValid(cellInput);
        });

        if (!hasInvalidInput) {
          handleOTPChange(value.split(""));
          focusInput(numInputs - 1);
        }
      } // for dealing with keyCode "229 Unidentified" on Android. Check if this is
      // still needed.


      if (nativeEvent.data === null && nativeEvent.inputType === "deleteContentBackward") {
        event.preventDefault();
        changeCodeAtFocus("");
        focusInput(activeInput - 1);
      } // Clear the input if it's not valid value because firefox allows
      // pasting non-numeric characters in a number type input


      event.target.value = "";
    }
  };

  var handleFocus = function handleFocus(event) {
    return function (index) {
      setActiveInput(index);
      event.target.select();
    };
  };

  var handleBlur = function handleBlur() {
    setActiveInput(activeInput - 1);
  };

  var handleKeyDown = function handleKeyDown(event) {
    var otp = getOTPValue();

    if ([event.code, event.key].includes("Backspace")) {
      event.preventDefault();
      changeCodeAtFocus("");
      focusInput(activeInput - 1);
    } else if (event.code === "Delete") {
      event.preventDefault();
      changeCodeAtFocus("");
    } else if (event.code === "ArrowLeft") {
      event.preventDefault();
      focusInput(activeInput - 1);
    } else if (event.code === "ArrowRight") {
      event.preventDefault();
      focusInput(activeInput + 1);
    } // React does not trigger onChange when the same value is entered
    // again. So we need to focus the next input manually in this case.
    else if (event.key === otp[activeInput]) {
        event.preventDefault();
        focusInput(activeInput + 1);
      } else if (event.code === "Spacebar" || event.code === "Space" || event.code === "ArrowUp" || event.code === "ArrowDown") {
        event.preventDefault();
      }
  };

  var focusInput = function focusInput(index) {
    var activeInput = Math.max(Math.min(numInputs - 1, index), 0);

    if (inputRefs.current[activeInput]) {
      var _inputRefs$current$ac, _inputRefs$current$ac2;

      (_inputRefs$current$ac = inputRefs.current[activeInput]) === null || _inputRefs$current$ac === void 0 ? void 0 : _inputRefs$current$ac.focus();
      (_inputRefs$current$ac2 = inputRefs.current[activeInput]) === null || _inputRefs$current$ac2 === void 0 ? void 0 : _inputRefs$current$ac2.select();
      setActiveInput(activeInput);
    }
  };

  var changeCodeAtFocus = function changeCodeAtFocus(value) {
    var otp = getOTPValue();
    otp[activeInput] = value[0];
    handleOTPChange(otp);
  };

  var handleOTPChange = function handleOTPChange(otp) {
    var otpValue = otp.join("");
    onChange(otpValue);
  };

  var handlePaste = function handlePaste(event) {
    event.preventDefault();
    var otp = getOTPValue();
    var nextActiveInput = activeInput; // Get pastedData in an array of max size (num of inputs - current position)

    var pastedData = event.clipboardData.getData("text/plain").slice(0, numInputs - activeInput).split(""); // Prevent pasting if the clipboard data contains non-numeric values for number inputs

    if (isInputNum && pastedData.some(function (value) {
      return isNaN(Number(value));
    })) {
      return;
    } // Paste data from focused input onwards


    for (var pos = 0; pos < numInputs; ++pos) {
      if (pos >= activeInput && pastedData.length > 0) {
        var _pastedData$shift;

        otp[pos] = (_pastedData$shift = pastedData.shift()) !== null && _pastedData$shift !== void 0 ? _pastedData$shift : "";
        nextActiveInput++;
      }
    }

    focusInput(nextActiveInput);
    handleOTPChange(otp);
  };

  return ___EmotionJSX("div", {
    style: Object.assign({
      display: "flex",
      alignItems: "center"
    }, isStyleObject(containerStyle) && containerStyle),
    className: typeof containerStyle === "string" ? containerStyle : undefined,
    onPaste: onPaste
  }, Array.from({
    length: numInputs
  }, function (_, index) {
    return index;
  }).map(function (index) {
    var _getOTPValue$index;

    return ___EmotionJSX(React.Fragment, {
      key: index
    }, renderInput({
      value: (_getOTPValue$index = getOTPValue()[index]) !== null && _getOTPValue$index !== void 0 ? _getOTPValue$index : "",
      placeholder: getPlaceholderValue() ? getPlaceholderValue()[index] : undefined,
      ref: function ref(element) {
        return inputRefs !== null && inputRefs !== void 0 && inputRefs.current ? inputRefs.current[index] = element : null;
      },
      onChange: handleChange,
      onFocus: function onFocus(event) {
        return handleFocus(event)(index);
      },
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onPaste: handlePaste,
      autoComplete: "off",
      "aria-label": "Please enter OTP character ".concat(index + 1),
      style: Object.assign(!skipDefaultStyles ? {
        width: "1em",
        textAlign: "center"
      } : {}, isStyleObject(inputStyle) ? inputStyle : {}),
      className: typeof inputStyle === "string" ? inputStyle : undefined,
      type: inputType,
      inputMode: isInputNum ? "numeric" : "text",
      onInput: handleInputChange
    }, index), index < numInputs - 1 && (typeof renderSeparator === "function" ? renderSeparator(index) : renderSeparator));
  }));
};

InternalOTPInput.propTypes = {
  value: PropTypes.string,
  numInputs: PropTypes.number,
  onChange: PropTypes.func,
  onPaste: PropTypes.func,
  renderInput: PropTypes.func,
  shouldAutoFocus: PropTypes.bool,
  index: PropTypes.number,
  placeholder: PropTypes.string,
  renderSeparator: PropTypes.string,
  containerStyle: PropTypes.any,
  inputStyle: PropTypes.any,
  inputType: PropTypes.any,
  skipDefaultStyles: PropTypes.bool
};
export default InternalOTPInput;